export const money = (n, showSign = false) => {
  const v = Number(n || 0);
  const str = v.toLocaleString("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (showSign && v > 0) return `+${str}`;
  return str;
};

export const TREATMENTS = {
  standard: { label: "GST 10%", short: "GST", color: "text-sky-700 bg-sky-50 border-sky-200" },
  gst_free: { label: "GST-Free", short: "Free", color: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  input_taxed: { label: "Input-Taxed", short: "Input", color: "text-amber-700 bg-amber-50 border-amber-200" },
};

export const PAYMENT_METHODS = {
  eftpos: "EFTPOS",
  cash: "Cash",
  bank_transfer: "Bank transfer",
  card: "Card",
  cheque: "Cheque",
  other: "Other",
};

export const fmtDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d + "T00:00:00").toLocaleDateString("en-AU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

// Current Australian financial-year quarter helpers
export function currentQuarter() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth(); // 0-11
  // AU BAS quarters: Q1 Jul-Sep, Q2 Oct-Dec, Q3 Jan-Mar, Q4 Apr-Jun
  let qStart, qEnd, label;
  if (m >= 6 && m <= 8) { qStart = new Date(y, 6, 1); qEnd = new Date(y, 8, 30); label = `Q1 Jul–Sep ${y}`; }
  else if (m >= 9 && m <= 11) { qStart = new Date(y, 9, 1); qEnd = new Date(y, 11, 31); label = `Q2 Oct–Dec ${y}`; }
  else if (m >= 0 && m <= 2) { qStart = new Date(y, 0, 1); qEnd = new Date(y, 2, 31); label = `Q3 Jan–Mar ${y}`; }
  else { qStart = new Date(y, 3, 1); qEnd = new Date(y, 5, 30); label = `Q4 Apr–Jun ${y}`; }
  const iso = (d) => d.toISOString().slice(0, 10);
  return { from: iso(qStart), to: iso(qEnd), label };
}

export function financialYear() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const startYear = m >= 6 ? y : y - 1;
  return {
    from: `${startYear}-07-01`,
    to: `${startYear + 1}-06-30`,
    label: `FY ${startYear}–${(startYear + 1).toString().slice(2)}`,
  };
}
